<!-- This is live data from adaptive_components.ashx -->
<template>
  <div class="sidearm-mm-run-game__game py-5">
    <div class="sidearm-mm-run-game__header w-100 bg-white flex">
      <div
        class="sidearm-mm-run-game__round border-light-a type-heading-bracket-plain  flex flex-justify-center flex-align-center"
      >
        Rd. {{ round.round }}
      </div>
      <div
        class="sidearm-mm-run-game__team relative pa-2 border-light-y flex flex-align-center flex-justify-center"
      >
        <div
          v-if="has_both_seeds"
          class="sidearm-mm-run-game__team-seed type-hero-small-plain mr-1"
        >
          #{{
            game.location_indicator === "A"
              ? $root.data.team.seed
              : game.opponent.seed
          }}
        </div>
        <div class="sidearm-mm-run-game__team-logo-container py-2">
          <div class="sidearm-mm-run-game__team-logo">
            <img
              v-if="game.location_indicator === 'A'"
              :src="$root.school_logo(96, 96)"
              :alt="
                $root.data.school.name ? $root.data.school.name : 'School Logo'
              "
            />
            <img
              v-else
              :src="
                game.opponent && game.opponent.image && game.opponent.image.url
                  ? `${$root.absolutize_cdn(
                      game.opponent.image.url
                    )}?width=96&height=96`
                  : `${$root.school_logo(96, 96)}&s.grayscale=100`
              "
              :alt="game.opponent ? game.opponent.title : 'Opponent Logo'"
            />
          </div>
        </div>
      </div>
      <div
        class="sidearm-mm-run-game__result border-light-a flex flex-column flex-justify-center flex-align-center "
      >
        <div
          v-if="game.opponent"
          class="sidearm-mm-run-game__matchup type-hero-small-plain pb-1"
        >
          {{ game.location_indicator === "A" ? "at" : "vs" }}
          {{ this.$root.shorten_name(game.opponent.title) }}
        </div>
        <div
          class="sidearm-mm-run-game__details type-paragraph flex flex-align-center flex-justify-center"
        >
          {{ game.date | moment("dddd, MMMM D") }}
          <span class="px-1 sidearm-mm-run-game__text-divider">
            /
          </span>
          {{ game.tbd ? "TBD" : moment(game.date).format("h:mm A") }}
        </div>
      </div>
      <div
        class="sidearm-mm-run-game__team relative pa-2 border-light-y flex flex-align-center flex-justify-center "
      >
        <div class="sidearm-mm-run-game__team-logo-container py-2">
          <div class="sidearm-mm-run-game__team-logo">
            <img
              v-if="game.location_indicator !== 'A'"
              :src="$root.school_logo(96, 96)"
              :alt="
                $root.data.school.name ? $root.data.school.name : 'School Logo'
              "
            />
            <img
              v-else
              :src="
                game.opponent && game.opponent.image && game.opponent.image.url
                  ? `${$root.absolutize_cdn(
                      game.opponent.image.url
                    )}?width=96&height=96`
                  : `${$root.school_logo(96, 96)}&s.grayscale=100`
              "
              :alt="game.opponent ? game.opponent.title : 'Opponent Logo'"
            />
          </div>
        </div>
        <div
          v-if="has_both_seeds"
          class="sidearm-mm-run-game__team-seed ml-1 type-hero-small-plain"
        >
          #{{
            game.location_indicator !== "A"
              ? $root.data.team.seed
              : game.opponent.seed
          }}
        </div>
      </div>
      <div
        class="sidearm-mm-run-game__button-container border-light-a relative"
      >
        <button
          @click="moveTo('gameday')"
          role="button"
          class="sidearm-mm-run-game__button absolute w-100 h-100"
        >
          <icon size="48">sf-arrow-right-minimal</icon>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "RunGameCurrent",
  props: {
    round: {
      type: Object,
      required: true
    }
  },
  data: () => ({}),
  computed: {
    game() {
      if (!this.round) {
        return null;
      }
      return this.round.game;
    },
    has_both_seeds() {
      return (
        this.$root.data.team.seed &&
        this.game.opponent && 
        this.game.opponent.seed &&
        +this.game.opponent.seed <= 16
      );
    }
  },
  mounted() {}
};
</script>

<style lang="scss" scoped>
.accessible-hide {
  position: absolute;
  left: -9999px;
  top: -9999px;
}
.sidearm-mm-play-btn {
  @include play-btn(3.75rem, $color-black);
}
.#{$prefix}-run-game {
  &__header {
    flex-wrap: wrap;
  }
  &__round {
    width: 100%;
    @include flex-item(0 1 auto);
  }
  &__team {
    width: 25%;
    @include flex-item(0 1 auto);
  }
  &__button-container {
    width: 100%;
    @include flex-item(0 1 auto);
  }
  &__result {
    width: 50%;
    @include flex-item(0 1 auto);
  }
  &__team-seed {
    @include flex-item(0 0 auto);
    min-width: 48px;
    text-align: center;
  }
  &__team-logo-container {
    width: 100%;
    max-width: 96px;
  }
  &__team-logo {
    width: 100%;
    position: relative;
    padding-bottom: 100%;
    img {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }
  &__button {
    @include base-reset();
    width: 100%;
    height: 100%;
  }
  &__score {
    color: $text-on-light;
    span::after {
      background-color: $text-on-light;
      height: 2px;
    }
  }
  &__score--winner {
    color: $color-black;
    span::before {
      position: absolute;
      top: 50%;
      left: 100%;
      content: "\e009";
      font-family: $font-icons;
      font-size: 1rem;
      padding: 0 $spacer * 2;
      transform: translate(0, -50%);
      color: $color-success;
    }
    &.sidearm-mm-run-game__score--left {
      span::before {
        left: auto;
        right: 100%;
        content: "\e010";
      }
    }
  }
  &__text-divider {
    display: inline-block;
    color: $text-on-light;
  }
  @media screen and (min-width: 1028px) {
    width: 75%;
    margin-left: 12.5%;

    &__team,
    &__button-container,
    &__round {
      width: 16.6667%;
    }
    &__result {
      width: 33.333%;
    }
  }
}
</style>
